import FinalValueColumn from 'src/views/Pages/Dashboard/Supplying/Shopping/ApprovalRange/FinalValueColumn.vue';
import i18n from 'src/i18n';
import InitialValueColumn from 'src/views/Pages/Dashboard/Supplying/Shopping/ApprovalRange/InitialValueColumn.vue';
import ResponsableNamesColumn from 'src/views/Pages/Dashboard/Supplying/Shopping/ApprovalRange/ResponsableNamesColumn.vue';
import RangeStatuses from 'src/views/Pages/Dashboard/Supplying/Shopping/ApprovalRange/RangeStatusesColumn.vue';

const configTable = () => {
    const tableColumns = [
        {
            prop: 'user_id',
            label: i18n.t('common_words.name'),
            minWidth: 100,
            sortable: true,
            formatter: (row) => {
                return `${row.user.first_name} ${row.user.last_name}`;
            },
        },
        {
            prop: 'business.name',
            minWidth: 110,
            label: i18n.t('common_words.company'),
            sortable: true,
        },
        {
            prop: 'approval_range_details',
            minWidth: 180,
            label: i18n.t('shopping.initial_value'),
            sortable: true,
            formatter: InitialValueColumn
        },
        {
            prop: 'approval_range_details',
            minWidth: 180,
            label: i18n.t('shopping.final_value'),
            sortable: true,
            formatter: FinalValueColumn
        },
        {
            prop: 'approval_range_details',
            minWidth: 250,
            label: i18n.t('shopping.approval_responsibles'),
            sortable: true,
            formatter: ResponsableNamesColumn
        },
        {
            prop: 'approval_range_details',
            minWidth: 150,
            label: i18n.t('shopping.approval_range_status'),
            sortable: true,
            formatter: RangeStatuses
        },
    ];

    return { tableColumns };
};

export default configTable;